type EventParameters = {
  event_category?: string
  experiment_id?: string | number
  variation_id?: string | number
  page?: string
  addon_id?: string | number
  addon_name?: string
  difference?: string
  quantity?: number
  range?: number
  reason?: string
  subscription_id?: string | number
  value?: string | number
  event_label?: string
  planLevel?: string
  fussy?: string
  coupon?: string
}

type Gtag = [string, string, EventParameters, ...any]

const sleep = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));

const queue: Gtag[] = []

const checkQueue = async () => {
  while (!window.gtag) await sleep(1000)
  queue.forEach((args) => window.gtag(...args))
  queue.length = 0
}

export default function gtag(...args: Gtag) {
  if (window.gtag) return window.gtag(...args);
  queue.push(args);
  if(queue.length === 1) checkQueue();
}
